// extracted by mini-css-extract-plugin
module.exports = {"table2":"CardModal_table2__3NT-z","header_wrapper":"CardModal_header_wrapper__26aBL","view_more":"CardModal_view_more__3hm5P"};